export default __webpack_public_path__ + "static/media/danji_cg_04_big.76b12510.jpg";